<template>
  <div class="page flex-col">
    <AppHeader />

    <div class="ad-banner">
      <div class="ad-banner-mask">
        <span class="ad-banner-zh">{{ isEnglish ? 'Counter-UAS Products' : '反无人机产品' }}</span>
        <span class="ad-banner-en">{{ isEnglish ? 'Anti-drone products' : 'Anti drone products' }}</span>
      </div>
    </div>

    <div class="ad-main">
      <!-- 列表页面包屑到分类为止，产品名仅在详情页显示 -->
      <nav class="ad-breadcrumb">
        <router-link :to="homeLink">{{ isEnglish ? 'Home' : '首页' }}</router-link>
        <span class="ad-sep">&gt;</span>
        <span>{{ isEnglish ? 'Counter-UAS Products' : '反无人机产品' }}</span>
        <span class="ad-sep">&gt;</span>
        <span class="ad-crumb-active">{{ categoryDisplayName }}</span>
      </nav>

      <div class="ad-title-row">
        <span class="ad-title-zh">{{ categoryDisplayName || (isEnglish ? 'Counter-UAS Products' : '反无人机产品') }}</span>
        <span class="ad-title-en">PRODUCTS</span>
      </div>
      <div class="ad-title-line"></div>

      <div class="ad-body">
        <AntiDroneSidebar />

        <div class="ad-content">
          <div class="ad-grid">
            <div
              v-for="(item, index) in currentProducts"
              :key="item.id || index"
              class="ad-card"
              :class="{ selected: selectedProductIndex === index }"
              @click="selectProduct(index)"
              @dblclick="goDetail(item)"
            >
              <div class="ad-card-img-wrap">
                <img class="ad-card-img" :src="item.image" :alt="productDisplayName(item)" />
              </div>
              <div class="ad-card-info">
                <div class="ad-card-title">
                  <span class="ad-card-name">{{ productDisplayName(item) }}</span>
                  <span v-if="productModel(item)" class="ad-card-model">{{ productModel(item) }}</span>
                </div>
                <a
                  class="ad-card-link"
                  href="javascript:;"
                  @click.stop.prevent="goDetail(item)"
                >{{ isEnglish ? 'View details' : '查看详情' }}</a>
              </div>
            </div>
          </div>
          <div v-if="!currentProducts.length" class="ad-empty">
            {{ isEnglish ? 'No products available' : '暂无产品数据' }}
          </div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AntiDroneSidebar from '@/components/AntiDroneSidebar.vue';
import { isEnglishRoute, withLang, siteHomeLink } from '@/utils/lang';

const defaultProductImg = require('./assets/img/FigmaDDSSlicePNG89bbbef5e0cf9e9d2d061a45a5ca017b.png');

export default {
  name: 'AntiDroneProductList',
  components: { AntiDroneSidebar },
  data() {
    return {
      categories: [],
      selectedProductIndex: 0
    };
  },
  computed: {
    isEnglish() {
      return isEnglishRoute(this.$route);
    },
    homeLink() {
      return siteHomeLink(this.$route);
    },
    activeCategoryId() {
      return this.$route.query.cat || 'detect';
    },
    activeCategoryIndex() {
      const idx = this.categories.findIndex((c) => c.id === this.activeCategoryId);
      return idx >= 0 ? idx : 0;
    },
    activeCategory() {
      return this.categories[this.activeCategoryIndex] || {
        name: '',
        label: '',
        products: []
      };
    },
    categoryDisplayName() {
      const cat = this.activeCategory;
      if (!cat) return '';
      if (this.isEnglish) return cat.labelEn || cat.nameEn || cat.label || cat.name || '';
      return cat.label || cat.name || '';
    },
    currentProducts() {
      return this.activeCategory.products || [];
    }
  },
  created() {
    this.fetchData();
  },
  watch: {
    activeCategoryId() {
      this.selectedProductIndex = 0;
    }
  },
  methods: {
    productDisplayName(item) {
      if (!item) return '';
      if (this.isEnglish) return item.nameEn || item.name || item.id || '';
      return item.name || item.id || '';
    },
    productModel(item) {
      if (!item) return '';
      if (this.isEnglish) return item.modelEn || item.model || '';
      return item.model || item.modelEn || '';
    },
    async fetchData() {
      try {
        const res = await fetch('/data/antidrone.json');
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data.categories)) {
          this.categories = data.categories.map((cat) => ({
            ...cat,
            products: (cat.products || []).map((item) => ({
              ...item,
              image: item.image || defaultProductImg
            }))
          }));
        }
      } catch (err) {
        console.warn('Failed to fetch antidrone.json:', err);
      }
    },
    selectProduct(index) {
      this.selectedProductIndex = index;
    },
    goDetail(item) {
      if (!item) return;
      let targetPath = item.path || '/products/integrated-system';
      if (this.activeCategoryId === 'solution') {
        targetPath = this.isEnglish
          ? item.pathEn || '/solutions/c-uas-en'
          : item.path || '/solutions/c-uas-zh';
        if (this.isEnglish) {
          this.$router.push({ path: targetPath, query: { lang: 'en' } });
        } else {
          this.$router.push({ path: targetPath });
        }
        return;
      }
      this.$router.push({
        path: targetPath,
        query: withLang(
          {
            id: item.id || '',
            cat: this.activeCategoryId
          },
          this.$route
        )
      });
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow-x: hidden;
}

.ad-banner {
  width: 100%;
  height: 360px;
  margin-top: 8px;
  background: url(./assets/img/FigmaDDSSlicePNG4bfbddd95358d0de5c2a6890b148e575.jpg)
    center center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ad-banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.28);
}

.ad-banner-mask {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.ad-banner-zh {
  color: #fff;
  font-size: 44px;
  font-weight: 900;
  line-height: 1.2;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.ad-banner-en {
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  font-weight: 500;
}

.ad-main {
  width: 1550px;
  max-width: 92%;
  margin: 0 auto;
  padding: 44px 0 80px;
  box-sizing: border-box;
}

.ad-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ad-breadcrumb a {
  color: #64748b;
  text-decoration: none;
}

.ad-breadcrumb a:hover {
  color: #1e40af;
}

.ad-sep {
  color: #94a3b8;
}

.ad-crumb-active {
  color: #1e40af;
  font-weight: 600;
}

.ad-title-row {
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin-top: 8px;
  margin-bottom: 14px;
}

.ad-title-zh {
  font-size: 28px;
  font-weight: 900;
  color: #0f172a;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ad-title-en {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #94a3b8;
}

.ad-title-line {
  width: 64px;
  height: 3px;
  background: #1e40af;
  margin-bottom: 32px;
}

.ad-body {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 56px;
  align-items: start;
}

.ad-content {
  min-width: 0;
}

.ad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.ad-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.ad-card:hover,
.ad-card.selected {
  border-color: #1e40af;
  box-shadow: 0 8px 24px rgba(30, 64, 175, 0.12);
}

.ad-card-img-wrap {
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #f8fafc !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ad-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ad-card-info {
  padding: 16px 18px 20px;
}

.ad-card-title {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 12px;
  margin-bottom: 10px;
}

.ad-card-name {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.4;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ad-card-model {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #2563eb;
  letter-spacing: 0.04em;
  font-family: "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  padding: 1px 8px;
  white-space: nowrap;
}

.ad-card-link {
  color: #1e40af;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.ad-card-link:hover {
  text-decoration: underline;
}

.ad-empty {
  padding: 48px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

@media (max-width: 1100px) {
  .ad-body {
    grid-template-columns: 1fr;
  }

  .ad-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .ad-breadcrumb {
    font-size: 13px;
  }
}

@media (max-width: 700px) {
  .ad-grid {
    grid-template-columns: 1fr;
  }

  .ad-banner-zh {
    font-size: 32px;
  }
}
</style>
